/**
 * Premium FAQ — Theme Editor convenience only. The accordion itself is
 * 100% native <details>/<summary>/name, no JS involved (see
 * custom-premium-faq.css). This file does exactly one thing: when a merchant
 * selects a FAQ block in the Theme Editor, open that FAQ so they can see
 * what they're editing. Everything else (exclusivity, keyboard, animation)
 * is already handled natively / by assets/global.js.
 *
 * Guarded by Shopify.designMode (same convention as assets/animations.js):
 * nothing is registered at all on the public storefront.
 *
 * The Theme Editor re-renders a section's HTML — including its <script>
 * tag — on every setting/block change, which re-executes this file each
 * time (the same reason custom-offer-selector.js guards its
 * customElements.define with `if (!customElements.get(...))`). The
 * window.__customPremiumFaqEditorBound flag is the equivalent guard here:
 * without it, every edit would stack another pair of document-level
 * listeners.
 */
if (Shopify.designMode && !window.__customPremiumFaqEditorBound) {
  window.__customPremiumFaqEditorBound = true;

  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('.custom-premium-faq__item');
    if (details) details.setAttribute('open', '');
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const details = event.target.closest('.custom-premium-faq__item');
    if (details) details.removeAttribute('open');
  });
}
